import xhrService from '../xhrService';

const url = `/api/clients/docTypesList`;
const Projecturl = `/api/clients/projectTab`;
const tenantDocTypesUrl = `/api/tenants/:tenantId/doc-types`;

type docTypesApiTypes = {
  get: () => Promise<any>;
};

type projectTabsApiTypes = {
  get: () => Promise<any>;
};

type tenantDocTypesApiTypes = {
  get: (tenantId: string) => Promise<any>;
  create: (
    tenantId: string,
    data: { name: string; is_custom: boolean },
  ) => Promise<any>;
  update: (
    tenantId: string,
    docTypeId: string,
    data: { name: string },
  ) => Promise<any>;
  delete: (tenantId: string, docTypeId: string) => Promise<any>;
};

export const docTypesApi: docTypesApiTypes = {
  get: () => {
    return xhrService.get(url).then((res) => res.data);
  },
};

export const projectTabsApi: projectTabsApiTypes = {
  get: () => {
    return xhrService.get(Projecturl).then((res) => res.data);
  },
};

export const tenantDocTypesApi: tenantDocTypesApiTypes = {
  get: (tenantId: string) => {
    const endpoint = tenantDocTypesUrl.replace(':tenantId', tenantId);

    return xhrService
      .get(endpoint)
      .then((res) => res.data)
      .catch((error) => {
        console.error('Error fetching tenant document types:', error);
        throw error;
      });
  },
  create: (tenantId: string, data: { name: string; is_custom: boolean }) => {
    const endpoint = tenantDocTypesUrl.replace(':tenantId', tenantId);

    return xhrService
      .post(endpoint, data)
      .then((res) => res.data)
      .catch((error) => {
        console.error('Error creating tenant document type:', error);
        throw error;
      });
  },
  update: (tenantId: string, docTypeId: string, data: { name: string }) => {
    const endpoint = `${tenantDocTypesUrl.replace(
      ':tenantId',
      tenantId,
    )}/${docTypeId}`;

    return xhrService
      .put(endpoint, data)
      .then((res) => res.data)
      .catch((error) => {
        console.error('Error updating tenant document type:', error);
        throw error;
      });
  },
  delete: (tenantId: string, docTypeId: string) => {
    const endpoint = `${tenantDocTypesUrl.replace(
      ':tenantId',
      tenantId,
    )}/${docTypeId}`;

    return xhrService
      .delete(endpoint)
      .then((res) => res.data)
      .catch((error) => {
        console.error('Error deleting tenant document type:', error);
        throw error;
      });
  },
};
